import { z } from "zod";

/** Tipos de negocio que acepta el backend (RF-14). */
export const BUSINESS_TYPES = [
  { value: "consultorio", label: "Consultorio o clínica" },
  { value: "evento", label: "Evento o convención" },
  { value: "agencia", label: "Agencia de publicidad" },
  { value: "empresa", label: "Empresa o RRHH" },
] as const;

export const BUSINESS_TYPE_VALUES = [
  "consultorio",
  "evento",
  "agencia",
  "empresa",
] as const;

/**
 * Validación del formulario de cotización (RF-2, RF-14).
 *
 * Espeja las reglas del backend: si acá pasa, el servidor también lo acepta
 * (mismos requeridos, mismo formato de teléfono y de email).
 */
export const quoteFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, "Escribí tu nombre completo")
    .max(80, "El nombre no puede exceder 80 caracteres"),

  email: z.string().trim().toLowerCase().email("Ingresá un email válido"),

  phone: z
    .string()
    .trim()
    .regex(/^\+?[1-9][\d]{0,15}$/, "Ingresá un teléfono válido (ej. +50761568575)"),

  businessType: z.enum(BUSINESS_TYPE_VALUES, {
    errorMap: () => ({ message: "Contanos qué tipo de negocio es" }),
  }),

  quantity: z.coerce
    .number({ invalid_type_error: "Ingresá la cantidad estimada" })
    .int("La cantidad debe ser un número entero")
    .min(1, "La cantidad debe ser al menos 1"),

  company: z.string().trim().max(120, "Máximo 120 caracteres").optional(),
  product: z.string().trim().max(120, "Máximo 120 caracteres").optional(),
  targetDate: z.string().optional(),
  message: z.string().trim().max(1000, "Máximo 1000 caracteres").optional(),

  /** Honeypot: invisible para las personas, los bots lo completan. */
  website: z.string().optional(),
});

export type QuoteFormValues = z.infer<typeof quoteFormSchema>;

/** Etiqueta legible del tipo de negocio (fuente única: BUSINESS_TYPES). */
export const businessTypeLabel = (value: string): string =>
  BUSINESS_TYPES.find((type) => type.value === value)?.label ?? value;
